<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card class="my-3" v-if="data">
      <v-toolbar class="mb-10" dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h3>{{ $i18n.t("Mark Payment Made") }}</h3>
      </v-toolbar>

      <v-expand-transition>
        <v-card-text class="py-0 text-body-1">
          <v-simple-table dense>
            <template v-slot:default>
              <thead class="thead">
                <tr>
                  <th class="text-left">
                    {{ $i18n.t("Seq No.") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Ref No.") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Date") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Created At") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Payment #") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Vendor Name") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Mode") }}
                  </th>
                  <th class="text-left">
                    {{ $i18n.t("Bank Details") }}
                  </th>
                  <th class="text-right">
                    {{ $i18n.t("Total Amount") }}
                  </th>
                  <th class="text-right">
                    {{ $i18n.t("Paid") }}
                  </th>
                  <th class="text-right">
                    {{ $i18n.t("TDS") }}
                  </th>
                </tr>
              </thead>
              <tbody class="tbody" v-for="payment in data" :key="payment._id">
                <tr style="height: 50px">
                  <td>{{ payment.seqNo }}</td>
                  <td>{{ payment.refNo }}</td>
                  <td>{{ formatDate(payment.date) }}</td>
                  <td>{{ payment.createdAt | moment("HH:mm DD MMM YYYY") }}</td>
                  <td>{{ payment.no }}</td>
                  <td>
                    {{ payment.vendorName ? payment.vendorName : "Other" }}
                  </td>
                  <td>{{ payment.paymentMode }}</td>
                  <td>
                    <span v-if="payment.bankAccount">
                      <span v-if="payment.bankAccount.accountNo">Acc. No. : {{ payment.bankAccount.accountNo }}<br></span>
                      <span v-if="payment.bankAccount.bankName">Bank: {{ payment.bankAccount.bankName }}<br></span>
                      <span v-if="payment.bankAccount.holderName">Holder: {{ payment.bankAccount.holderName }}<br></span>
                      <span v-if="payment.bankAccount.ifsc">IFSC: {{ payment.bankAccount.ifsc }}<br></span>
                      <span v-if="payment.bankAccount.swiftCode">SWIFT: {{ payment.bankAccount.swiftCode }}</span>
                    </span>
                  </td>
                  <td class="text-right">
                    {{ payment.currency }} {{ payment.totalAmount }}
                  </td>
                  <td class="text-right">
                    <v-text-field
                      :label="$i18n.t('Amount')"
                      type="number"
                      @change="getTotalAmount()"
                      v-model="payment.amountPaid"
                    />
                  </td>
                  <td class="text-right">
                    <v-text-field
                      :label="$i18n.t('TDS')"
                      type="number"
                      v-model="payment.tdsAmount"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-form id="form">
            <v-col>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding: 27px"
                  >
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          :label="$i18n.t('Amount Paid')"
                          v-model="totalAmount"
                          disabled
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="3" lg="2">
                        <z-date-picker
                          :label="$i18n.t('Date')"
                          v-model="date"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          :label="$i18n.t('Payment Ref No')"
                          v-model="paymentRefNo"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" lg="2">
                        <z-name-master-select
                          v-model="paymentMode"
                          :type="7"
                          @click.native.stop
                          :label="$i18n.t('Payment Mode')"
                          :hideAddNew="true"
                        />
                      </v-col>

                      <!-- <v-col cols="12" sm="12" md="6" lg="2">
                        <v-select
                          v-model="paymentdone.paidTo"
                          type="number"
                          :label="$i18n.t('Paid To')"
                          :items="[
                            { name: 'Paid To Vendor', value: 1 },
                            { name: 'Paid To Driver', value: 2 },
                            { name: 'Paid To Agent', value: 3 },
                            { name: 'Paid to Truck Owner', value: 4 },
                            { name: 'Others', value: 5 },
                          ]"
                          item-text="name"
                          item-value="value"
                        />
                      </v-col> -->

                      <v-col cols="12" sm="4" md="2" lg="1">
                        <v-btn
                          class="float-right"
                          color="success"
                          :loading="loading"
                          @click="markPayment"
                        >
                          <h3>{{ $i18n.t("Save") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PaymentPendingEntry",
  props: {
    showDialog: {
      default: false,
    },
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
})
export default class PaymentPendingEntry extends Vue {
  data = null;
  dialog = false;
  totalAmount = "";
  paymentRefNo = null;
  paymentMode = null;
  date = null;

  get loading() {
    return common.loading;
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }

  async markPayment(payment) {
    if (!this.paymentRefNo) {
      common.setError("Please provide Payment Ref no");
      return;
    }
    common.setLoading(true);
    try {
      const _ids = [];
      for (let i = 0; i < this.data.length; i++) {
        _ids.push({
          _id: this.data[i]._id,
          amountPaid: this.data[i].amountPaid,
          tdsAmount: this.data[i].tdsAmount,
        });
      }
      const post = {
        paymentRefNo: this.paymentRefNo,
        data: _ids,
        paymentMode: this.paymentMode,
        date: this.date,
      };
      await doPost("/api/paymentmade/pending/mark/paid", post);
      common.showMessage("Entry Successfully Saved");
      this.closeDialog();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    if (this.value) {
      this.data = this.value;
      this.setTotalAmount();
      this.postDataValueSet();
    }
  }

  postDataValueSet() {
    if (this.data && this.data.length > 0) {
      this.date = this.data[0].date;
      this.paymentMode = this.data[0].paymentMode;
    }
  }

  @Watch("value")
  onValueChange(val) {
  // console.log(val);
    this.data = val;
    this.postDataValueSet();
    this.setTotalAmount();
  }

  setTotalAmount() {
    for (let i = 0; i < this.data.length; i++) {
      this.data[i].amountPaid = this.data[i].totalAmount;
      this.data[i].tdsAmount = 0; //this.data[i].totalAmount;
    }
    this.getTotalAmount();
  }

  getTotalAmount() {
    let curr;
    let total = 0;
    for (let i = 0; i < this.data.length; i++) {
      curr = this.data[i].currency;
      total += parseFloat(this.data[i].amountPaid);
    }
    this.totalAmount = curr + " " + total.toFixed(2);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  subtract(from, value) {
    if (!this.isSet(from)) from = 0;
    if (!this.isSet(value)) value = 0;
    return this.round(from) - this.round(value);
  }

  round(value) {
    return Number(Math.round(value + "e" + 2) + "e-" + 2);
  }
}
</script>
